import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class ApiservicesService {
  adminurl: string = "https://api.projectnow.in/index.php/";
  jsonUrl = "https://api.projectnow.in/jsons/";

  constructor(private http: HttpClient) {
    if (window.location.host == "dietmaker.projectnow.in") {
      this.adminurl = "https://api.projectnow.in/index.php/";
    } else {
      this.adminurl = "https://api.projectnow.in/stg/index.php/";
      this.jsonUrl = "https://api.projectnow.in/stg/jsons/";
    }

    // if (window.location.host == 'projectnow.pixoloproductions.com') {
    //   this.adminurl = 'https://www.pixoloproductions.com/projectnow/rest/index.php/';
    // } else {
    //   this.adminurl = 'https://www.pixoloproductions.com/projectnow/testapi/index.php/';
    // }
  }

  dologin({ contact, device_fingerprint }) {
    console.log("login api");
    return this.http.get(
      this.adminurl +
        "nutritionist/getnutritionsitsbycontact?mobile=" +
        encodeURIComponent(contact) +
        "&device_fingerprint=" +
        device_fingerprint
    );
  }

  checkuser(contact) {
    console.log("login api");
    return this.http.get(
      this.adminurl +
        "nutritionist/checknutritionistexist?mobile=" +
        encodeURIComponent(contact)
    );
  }

  storeToken(user_id, usertype, token) {
    var formData = new FormData();
    let data = {
      user_id: user_id,
      user_type: 0,
      token: token,
    };
    formData.append("data", JSON.stringify(data));
    // formData.append('user_id', JSON.stringify(user_id));
    // formData.append('usertype', JSON.stringify(usertype));
    // formData.append('token', JSON.stringify(token));
    return this.http.post(this.adminurl + "user_device/postinsert", formData);
  }

  getcalories(id) {
    return this.http.get(this.adminurl + "users/getuserbmibmr?id=" + id);
  }

  getallusers(id, is_parent, startlimit, endlimit) {
    return this.http.get(
      this.adminurl +
        "users/getusersbynutritionistid?nutritionist_id=" +
        id +
        "&is_parent=" +
        is_parent +
        "&start_limit=" +
        startlimit +
        "&end_limit=" +
        endlimit
    );
  }

  getallmeals() {
    return this.http.get(this.adminurl + "mealtypes/getall");
  }

  getfoodtype() {
    return this.http.get(this.adminurl + "foods/getfoodwithmeasurement");
  }

  insertdiet(diet) {
    var formData = new FormData();
    formData.append("data", JSON.stringify(diet));
    return this.http.post(this.adminurl + "diet/postinsert", formData);
  }

  getcaloriesforuser(id) {
    return this.http.get(
      this.adminurl + "users/getcaloriesforuser?user_id=" + id
    );
  }

  insertdietdata(dietdata) {
    console.log(dietdata);
    return this.http.post(
      this.adminurl + "dietfood/insertdietfood",
      JSON.stringify(dietdata)
    );
  }

  updateDiet(diet) {
    var formData = new FormData();
    return this.http.post(
      this.adminurl + "dietfood/updatedietfood",
      JSON.stringify(diet)
    );
  }

  getfooddatabyid(id) {
    return this.http.get(
      this.adminurl + "foods/getfoodwithmeasurementbyid?food_id=" + id
    );
  }

  getfoodbyinitialcharacters(element, type, ethnicity_preference) {
    return this.http.get(
      this.adminurl +
        "foods/getfoodbyinitialcharacters?initials=" +
        element +
        "&type=" +
        type +
        "&user_ethnicity=" +
        JSON.stringify(ethnicity_preference)
    );
  }

  getalluserdiets(userid) {
    return this.http.get(
      this.adminurl + "diet/getalluserdiets?user_id=" + userid
    );
  }

  getallusermeals(userid) {
    return this.http.get(
      this.adminurl + "diet/getallusermeals?user_id=" + userid
    );
  }

  getalldiets(dietid) {
    return this.http.get(
      this.adminurl + "diet/getmealsbydietid?diet_id=" + dietid
    );
  }

  getalldata(table) {
    return this.http.get(this.adminurl + table + "/getall");
  }
  sendotp(otp, contact) {
    return this.http.get(
      this.adminurl +
        "users/sendotp?to=" +
        encodeURIComponent(contact) +
        "&otp=" +
        otp
    );
  }

  getalluserinfo(id) {
    return this.http.get(
      this.adminurl + "users/getuserprofilefordietmaker?user_id=" + id
    );
  }

  updateUserProfileForDietMaker(userInfo, userId) {
    const userProfileform = new FormData();
    userProfileform.append("user_id", userId);
    userProfileform.append("user_profile", JSON.stringify(userInfo));
    return this.http.post(
      this.adminurl + "users/updateuserprofilefordietmaker",
      userProfileform
    );
  }

  getallusermetric(id) {
    console.log(id);
    return this.http.get(
      this.adminurl + "user_metric/getsystemmetricsbyuserid?user_id=" + id
    );
  }

  insertnewmetricvalue(obj) {
    const metricdata = new FormData();
    metricdata.append("data", JSON.stringify(obj));
    return this.http.post(this.adminurl + "user_metric/postinsert", metricdata);
  }

  printpdf(id) {
    return this.http.get(this.adminurl + "diet/printdietpdf?diet_id=" + id);
  }

  getmanyby(table, fieldname, value) {
    return this.http.get(
      this.adminurl +
        table +
        "/getmanyby?field=" +
        fieldname +
        "&value=" +
        value
    );
  }

  uploadimg(file, table, path) {
    var formdata = new FormData();
    formdata.append("image", file);
    formdata.append("path", path);
    return this.http.post(this.adminurl + table + "/uploadImage", formdata, {
      responseType: "text",
    });
  }

  adduser(user, userextrainfo, userplan, user_metric) {
    console.log(user);
    console.log(userextrainfo);
    console.log(userplan);
    const formdata = new FormData();
    formdata.append("user", JSON.stringify(user));
    formdata.append("user_extra", JSON.stringify(userextrainfo));
    formdata.append("user_plan", JSON.stringify(userplan));
    formdata.append("user_metric", JSON.stringify(user_metric));
    return this.http.post(this.adminurl + "users/addnewuser", formdata);
  }

  getallreciepe(food_id) {
    return this.http.get(
      this.adminurl + "recipes/getrecipebyfoodid?food_id=" + food_id
    );
  }

  getingredientsbyfoodrecipeid(id) {
    return this.http.get(
      this.adminurl +
        "recipes/getingredientsbyfoodrecipeid?food_recipe_id=" +
        id
    );
  }

  checkcontactexist(contact) {
    const formdata = new FormData();
    formdata.append("phone", contact);
    return this.http.post(this.adminurl + "users/checkcontactexists", formdata);
  }

  addPost(obj) {
    var formdata = new FormData();
    formdata.append("data", JSON.stringify(obj));
    return this.http.post(this.adminurl + "posts/postinsert", formdata);
  }

  addPostWithImages(post) {
    var formdata = new FormData();
    formdata.append("data", JSON.stringify(post));
    return this.http.post(this.adminurl + "postimages/insert_many", formdata);
  }

  getPosts(id) {
    return this.http.get(this.adminurl + "posts/getallposts?user_id=" + id);
  }

  cancelBooking(id) {
    return this.http.get(
      this.adminurl +
        "user_booking/cancelbooking?appointment_id=" +
        id +
        "&cancelled_by=0"
    );
  }

  getBookings(id, date) {
    return this.http.get(
      this.adminurl +
        "user_booking/getbookingsbynutritionistid?nutritionist_id=" +
        id +
        "&date=" +
        date
    );
  }

  getBookingSlots(date, id) {
    return this.http.get(
      this.adminurl +
        "user_booking/getavailableslots?nutritionist_id=" +
        id +
        "&booking_date=" +
        date
    );
  }

  insertBooking(obj) {
    var formdata = new FormData();
    formdata.append("user_booking", JSON.stringify(obj));

    return this.http.post(
      this.adminurl + "user_booking/insertuserbooking",
      formdata
    );
  }

  getusernames(initial, nutritionist_id, is_parent) {
    return this.http.get(
      this.adminurl +
        "users/getusersdropdown?initials=" +
        initial +
        "&nutritionist_id=" +
        nutritionist_id +
        "&is_parent=" +
        is_parent
    );
  }

  getDatesFromDietId(dietId) {
    return this.http.get(this.adminurl + "diet/getdietdate?diet_id=" + dietId);
  }

  getidforupdate(diet, diet_id) {
    diet.diet_id = diet_id;
    var formData = new FormData();
    formData.append("data", JSON.stringify(diet));
    return this.http.post(this.adminurl + "diet/updatediet", formData);
  }

  getDietForUpdate(diet_id) {
    return this.http.get(
      this.adminurl + "diet/getdiettoedit?diet_id=" + diet_id
    );
  }

  getuserethnicitypreference(user_id) {
    return this.http.get(
      this.adminurl +
        "user_ethnicity_preference/getethnicitybyuserid?user_id=" +
        user_id
    );
  }

  getRegisteredUser(nutritionist_id) {
    return this.http.get(
      this.adminurl +
        "user_plan/getuserstoapprove?nutritionist_id=" +
        nutritionist_id
    );
  }

  approveMember(userplan_id, duration, start_date, user_id, nutritionist_id) {
    return this.http.get(
      this.adminurl +
        "user_plan/approveuserplan?userplan_id=" +
        userplan_id +
        "&duration=" +
        duration +
        "&start_date=" +
        start_date +
        "&user_id=" +
        user_id +
        "&nutritionist_id=" +
        nutritionist_id
    );
  }

  deletePost(pid) {
    // return this.http.get(this.adminurl + `posts/deletebyid?id=${pid}`);
    // var formData = new FormData();
    let obj = {
      post_id: pid,
    };
    // formData.append('data', JSON.stringify(obj));
    return this.http.post(
      this.adminurl + "posts/deletepost",
      JSON.stringify(obj)
    );
  }

  getSearchUser(id, parent, searchInput) {
    var formData = new FormData();
    formData.append("search_text", searchInput);
    formData.append("nutritionist_id", id);
    formData.append("is_parent", parent);
    return this.http.post(this.adminurl + "users/searchusersbyname", formData);
  }

  getPreMadeDiets() {
    return this.http.get(this.jsonUrl + "pre-diets.json");
  }

  deleteUserDiet(nutr_id, diet_id) {
    var formData = new FormData();
    formData.append("diet_id", diet_id);
    formData.append("nutritionist_id", nutr_id);
    console.log("Delete user diet api called");
    return this.http.post(this.adminurl + "diet/deletefuturediet", formData);
  }
}
